<template>
  <div class="company-data-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-2 has-text-left has-text-primary has-text-weight-bold dm-sans">
            Dados do Negócio
          </p>
        </div>
      </div>
      <div :key="key">
        <div class="columns">
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Razão Social</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companySocialReason"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.social_reason"
                >
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Nome Fantasia</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyFantasyName"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.fantasy_name"
                >
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">CNPJ</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyCnpjDocument"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.cnpj_document"
                  v-mask="'##.###.###/####-##'"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">CEP</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyZipcode"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.zipcode"
                  v-mask="'#####-###'"
                  @change="callViaCep"
                >
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Endereço</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyStreet"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.street"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Número</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyNumber"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.number"
                >
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Bairro</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyNeighbourhood"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.neighbourhood"
                >
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Complemento</label>
              <div class="control">
                <input
                  name="companyAdditionalDetails"
                  class="input"
                  type="text"
                  v-model="formData.company.data.additional_details"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Cidade</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyCity"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.city"
                >
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Estado (UF)</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyState"
                  required
                  class="input"
                  type="text"
                  v-model="formData.company.data.state"
                  v-mask="'XX'"
                >
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-light is-size-5">Email Para Contato e Boleto</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  name="companyEmail"
                  required
                  class="input"
                  type="email"
                  v-model="formData.company.data.email"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="columns is-12 p-3">
        <label class="checkbox">
          <input type="checkbox" v-model="terms">
          <span class="is-size-5"> Eu concordo com todos os <a href="https://pedbot.s3.amazonaws.com/pedbot/pdf/16578277800iSTGPaeEN.pdf" target="_blank">termos e condições da plataforma Pedbot</a></span>
        </label>
      </div>
    </div>
    <div class="column is-12 pt-6">
      <next-button
        @nextTab="nextTab"
        position="right"
        sizeClass="is-one-third"
        ref="nextButton"
      ></next-button>
    </div>
  </div>
</template>

<script>

import viaCepApi from '@/apis/viaCep'
import { mask } from 'vue-the-mask'
import NextButton from './NextButton'
import legalGuardianApi from '@/apis/legalGuardians'
import technicalManagerApi from '@/apis/technicalManagers'
import recommenderApi from '@/apis/recommenders'
import companyApi from '@/apis/companies'
import customerApi from '@/apis/customers'

export default {

  name: 'registration-data',

  components: {
    NextButton
  },

  data() {
    return {
      key: 0,
      terms: false
    }
  },

  directives: { mask },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  methods: {
    removeSpecialChars(string) {
      return string.replace(/[^A-Z0-9]+/ig, "")
    },
    async callViaCep() {
      if (this.formData.company.data.zipcode.length === 9) {
        const address = await viaCepApi.get(this.removeSpecialChars(this.formData.company.data.zipcode))
        this.formData.company.data.street = address.logradouro
        this.formData.company.data.neighbourhood = address.bairro
        this.formData.company.data.city = address.localidade
        this.formData.company.data.state = address.uf
        this.key++
      }
    },
    async createCustomer() {
      try {
        // legalGuardian
        const legalGuardianData = JSON.parse(JSON.stringify(this.formData.legalGuardian.data))
        legalGuardianData.phone_number = '55' + this.removeSpecialChars(legalGuardianData.phone_number)
        legalGuardianData.rg_document = this.removeSpecialChars(legalGuardianData.rg_document)
        legalGuardianData.cpf_document = this.removeSpecialChars(legalGuardianData.cpf_document)
        const legalGuardian = await legalGuardianApi.create(legalGuardianData)

        // technicalManager
        const technicalManagerData = JSON.parse(JSON.stringify(this.formData.technicalManager.data))
        technicalManagerData.phone_number = '55' + this.removeSpecialChars(technicalManagerData.phone_number)
        const technicalManager = await technicalManagerApi.create(technicalManagerData)

        // company
        if (!this.formData.company.data.additional_details) {
          this.formData.company.data.additional_details = ''
        }
        const company = await companyApi.create(this.formData.company.data)
        const customerData = {
          company_id: company.id,
          legal_guardian_id: legalGuardian.id,
          technical_manager_id: technicalManager.id
        }

        // recommender
        if (this.formData.recommender.data.name) {
          const recommenderData = JSON.parse(JSON.stringify(this.formData.recommender.data))
          recommenderData.phone_number = '55' + this.removeSpecialChars(recommenderData.phone_number)
          const recommender = await recommenderApi.create(recommenderData)
          customerData.recommender_id = recommender.id
        }

        if (this.formData.partner.data.id) {
          customerData.partner_id = this.formData.partner.data.id
        }

        return await customerApi.create(customerData)
      } catch (error) {
        this.$refs.nextButton.isClicked = false
        this.$flashStorage.destroyAll()
        const errors = error.response.data.error
        for (const error of errors) {
          if (error.parameter === 'registry_code') {
            this.flashError('O CNPJ informado é ' + error.message);
          } else if (error.parameter === 'address.state') {
            this.flashError('O Estado (UF) informado ' + error.message);
          } else if (error.parameter === 'phones.number') {
            this.flashError(
                'O(s) número(s) de telefone(s) do responsável legal e(ou) responsável técnico é(são) inválido(s). '
                + 'Volte uma tela e revise o(s) mesmo(s) por favor.'
            );
          }
        }
        throw error;
      }
    },
    nextTab() {
      this.$refs.nextButton.isClicked = true
      if (this.terms === false) {
        this.$flashStorage.destroyAll()
        this.$refs.nextButton.isClicked = false
        return this.flashError('Você deve aceitar os termos e condições para prosseguir.')
      }
      this.$validator.validate().then(async (result) => {
        if (result) {
          this.$flashStorage.destroyAll()
          this.formData.customer.data = await this.createCustomer()

          this.$emit('nextTab')
        } else {
          this.$flashStorage.destroyAll()
          this.$refs.nextButton.isClicked = false
          this.flashError('Verifique se você preencheu todos os campos corretamente.')
        }
        this.$refs.nextButton.isClicked = false
      })
    }
  }

}

</script>

<style lang="scss">
.mb-label {
  margin-bottom: 0.5em;
}
</style>
